<template>
  <div>
    <v-text-field
      prepend-icon="mdi-web"
      :label="value.caption"
      v-model="urlVal"
      :name="value.name"
      :clearable="true"
      :readonly="readonly"
      :filled="filled"
      :required="value == null ? false : value.required"
      :rules="[rules.hashttps]"
    >
      <template #label>
        <span v-if="value.required" class="red--text"><strong>* </strong></span
        >{{ value.caption }}
      </template>
    </v-text-field>
    <!-- <p v-if="urlErrorFlag" class="errorUrl" style="color: red">
      {{ $t("startup-screen.urlerrorMsg") }}
    </p> -->
  </div>
</template>

<script>
export default {
  name: "MyFormURL",
  data() {
    return {
      urlErrorFlag: false,
      rules: {
        hashttps: (value) => {
          if (value != null && value != undefined) {
            var siteUrl = window.location.href;
            console.log(
              "siteurl",
              this.validateURL(siteUrl),
              value.indexOf("http://")
            );
            if (
              this.validateURL(siteUrl) == "https" &&
              value.indexOf("http://") == 0
            ) {
              console.log("https expected");
              _valid = false;
              return (
                _valid || window.vueAppInstance.$i18n.t("common.httpsexpected")
              );
            }
            if (
              this.validateURL(siteUrl) == "http" &&
              value.indexOf("https://") == 0
            ) {
              console.log("http expected");
              _valid = false;
              return (
                _valid || window.vueAppInstance.$i18n.t("common.httpexpected")
              );
            }
            if (this.value.required && value == "") {
              _valid = false;
              return _valid || this.$i18n.t("common.required");
            }

            let _valid = true;

            if (value) _valid = value.indexOf("https://") == 0;
            if (!this.value.httpsRequired) return true;

            if (value == "" && !this.value.required) {
              _valid = true;
            } else {
              _valid = false;
            }
            this.value.valid = _valid;

            return (
              _valid || window.vueAppInstance.$i18n.t("common.httpsrequired")
            );
          } else return true;
        },
      },
    };
  },
  watch: {
    urlErrorFlag(data) {
      console.log("urlErrorFlag", data);
    },
  },
  computed: {
    urlVal: {
      get() {
        if (this.value) {
          return this.value.value;
        } else {
          return "";
        }
      },
      set(newVal) {
        // this.urlVal = newVal;
        this.$emit("changedValue", newVal);
        console.log("newval", newVal);
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          name: "MyFormInputNotSet",
          value: "",
          caption: "not set",
          required: false,
          valid: true,
          httpsRequired: false,
        };
      },
    },
    readonly: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    filled: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  methods: {
    validateURL(link) {
      console.log("MyFormURL link: " + link);
      if (link && link.indexOf("https://") == 0) {
        console.log("The link has https ");
        return "https";
      }
      if (link && link.indexOf("http://") == 0) {
        console.log("The link has http ");
        return "http";
      } else {
        console.log("The link doesn't have http or https.");
        return "";
      }
    },
  },
};
</script>

<style scoped>
.errorUrl {
  padding-left: 30px;
  font-size: 1.5em;
}
</style>
